import React, { useState, useMemo, useEffect } from "react";
import { MdEdit, MdDelete, MdFilterList } from "react-icons/md";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import Table from "../../../components/common/Table/Table";
import Button from "../../../components/common/Button/Button";
import InputSearch from "../../../components/common/Inputs/InputSearch/InputSearch";
import { FiDownload } from "react-icons/fi";
import { GrAdd } from "react-icons/gr";
import { LuArrowDownUp } from "react-icons/lu";
import { getApiInstance } from "../../../utils/api";
import { useZone } from "../../../context/ZoneContext";

const columnasIntermediarios = [
  { key: "id", label: "codIntermediario", visible: false },
  { key: "codIntermediario", label: "codIntermediario", visible: false },
  { key: "nombre", label: "Nombre", visible: true, sortable: true },
  { key: "cif", label: "CIF", visible: true, sortable: true },
  { key: "contacto", label: "Contacto", visible: true, sortable: true },
  { key: "telefono", label: "Teléfono", visible: true, sortable: true },
  { key: "eMail", label: "Email", visible: true, sortable: true },
];

const filterFields = [
  { key: "nombre", label: "Nombre", type: "multiselect" },
  { key: "cif", label: "CIF", type: "multiselect" },
  { key: "contacto", label: "Contacto", type: "multiselect" },
  { key: "telefono", label: "Teléfono", type: "multiselect" },
];

export default function Intermediarios() {
  const [intermediarios, setIntermediarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { selectedZone } = useZone();

  useEffect(() => {
    fetchIntermediarios();
  }, [selectedZone]);

  const fetchIntermediarios = async () => {
    setLoading(true);
    const api = getApiInstance();

    try {
      let intermediariosData = [];

      const response = await api.get(
        `/api/Intermediarios/GetIntermediariosByZona/${selectedZone.value}`
      );
      intermediariosData = response.data;

      console.log("Intermediarios data fetched:", intermediariosData);

      setIntermediarios(intermediariosData);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar los intermediarios. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="muebles-pages__error-message">
        Cargando comunidades...
      </div>
    );
  if (error)
    return <div className="muebles-pages__error-message">Error: {error}</div>;

  return (
    <PageLayout
      title="Intermediarios"
      subtitle="Gestión de intermediarios registrados en el sistema"
    >
      <Table
        columns={columnasIntermediarios}
        dataTable={intermediarios}
        showCheckboxes={true}
        noResultsMessage="No se han encontrado intermediarios."
        actions={["Eliminar", "Editar"]}
        searchTerms={["Nombre", "CIF", "Contacto", "Teléfono", "Email"]}
        elementName="Intermediario"
        formElements={[
          {
            elements: [
              {
                name: "nombre",
                type: "text",
                label: "Nombre",
                placeholder: "Ingrese su nombre",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
              {
                name: "cif",
                type: "text",
                label: "CIF",
                placeholder: "Ingrese el CIF",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
              {
                name: "direccion",
                type: "text",
                label: "Dirección",
                placeholder: "Ingrese la dirección",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
              {
                name: "localidad",
                type: "text",
                label: "Localidad",
                placeholder: "Ingrese la localidad",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
              {
                name: "contacto",
                type: "tel",
                label: "Contacto",
                placeholder: "Ingrese el número de teléfono",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
              {
                name: "telefono",
                type: "tel",
                label: "Teléfono",
                placeholder: "Ingrese el número de teléfono",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
              {
                name: "eMail",
                type: "email",
                label: "Email",
                placeholder: "Ingrese su dirección email",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
              {
                name: "codZona",
                type: "number",
                label: "Zona",
                visible: false,
                defaultValue: selectedZone.value,
              },
            ],
          },
        ]}
        filterFields={filterFields}
        loading={loading}
        keyProp="codIntermediario"
		sortProp="nombre"
        addApiUrl="/api/Intermediarios/SetIntermediario"
        editApiUrl="/api/Intermediarios/EditIntermediario"
        deleteApiUrl="/api/Intermediarios/DeleteIntermediario"
      />
    </PageLayout>
  );
}
